export enum QUIZ_TYPES {
  INHOUSE_QUESTION    = 'inhouseQuestion',
  KNOCKOUT_QUESTIONS  = 'knockoutQuestions',
  BUSINESS_QUESTIONS  = 'businessQuestions',
  VIDEO_QUESTIONS     = 'videoQuestions'
}
